import { tagTypes } from '../constants';
import { advancementTypes } from '@modules/shared';

export type AdvancementDetailsArgs = {
  advancementId: string;
}


export const getAdvancementDetailsQuery = (advancementType: Omit<advancementTypes, 'AWARDS'>) => ({
  query: (arg: AdvancementDetailsArgs) => ({
    url: `/advancements/v2/${advancementType}/${arg.advancementId}`,
    method: 'GET',
  }),
  providesTags: (_result: unknown, error: unknown, arg: AdvancementDetailsArgs) =>
    error
      ? []
      : [
        {
          type: tagTypes.AdvancementDetails,
          id: `${advancementType}-${arg.advancementId}`,
        },
      ],
});

export type GeneralAdvancementDetailsArgs = {
  advancementType: Omit<advancementTypes, advancementTypes.AWARDS>;
  advancementId: string;
}

export const getGeneralAdvancementDetailsQuery = () => ({
  query: (arg: GeneralAdvancementDetailsArgs) => ({
    url: `/advancements/v2/${arg.advancementType}/${arg.advancementId}`,
    method: 'GET',
  }),
  providesTags: (_result: unknown, error: unknown, arg: GeneralAdvancementDetailsArgs) =>
    error
      ? []
      : [
        {
          type: tagTypes.AdvancementDetails,
          id: `${arg.advancementType}-${arg.advancementId}`,
        },
      ],
});
